
import { tableColumns } from '../../logic/dataTable.js';
import './AttendanceTableManager.scss';
import useValidatingAttendancesByManager from '../../logic/useValidatingAttendancesByManager.js';
import { Popconfirm, Spin } from 'antd';

export default function AttendanceTableManager({dateFilter}) {
  const { data, isFetching , handleValidateAttendances, handleToggle} = useValidatingAttendancesByManager(dateFilter);
    const handleConfirmSubmit = () => {
    handleValidateAttendances();
  };


return (
  <>
  {isFetching ? (
    <div className="no-data-message">
      <Spin />
    </div>
  ) : data.length === 0 ? (
    <div className="no-data-message">No data</div>
  ) : (
  <><div className="attendance-table-container">
            <table className="attendance-table">
              <thead>
                <tr>
                  {tableColumns.map((column, index) => (
                    <th key={index}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data?.map((record, index) => (
                  <tr key={index}>

                    <td>{record.user.firstName} {record.user.lastName}</td>
                    <td>
                      {record.sessions.map((session, sessionIndex) => (
                        <div className="tr-border-row1" key={sessionIndex}>
                          <tr>
                            Session {sessionIndex + 1}
                          </tr>
                        </div>
                      ))}

                    </td>
                    {record.sessions.map((session, sessionIndex) => (
                      session.attendances.map((attendance, attendanceIndex) => (
                        <div className="tr-border-row1">
                          <tr key={attendanceIndex}>
                            <div className="presence-status">
                              <label>{attendance.status === "present" ? "Present" : "Absent"}</label>
                            </div>
                            <label className="toggle">
                              <input
                                type="checkbox" 
                                checked = {attendance.status === "present" ? true : false}
                                onChange={() => {
                                  handleToggle(index, sessionIndex)}}
                                />
                              <span className="slider"> </span>
                            </label>
                          </tr>
                        </div>

                      ))

                    ))}
                  </tr>
                ))}
              </tbody>
            </table>

          </div>
          <div className="submit-btn-container">
              <Popconfirm
                title="Are you sure you want to validate the attendances records?"
                onConfirm={() => handleConfirmSubmit()}
                okText="Yes"
                cancelText="No"
              >
                <button className="submit-button">Submit</button>
              </Popconfirm>  </div>
              </>
  )}
  </>
);
}
